// extracted by mini-css-extract-plugin
export default {"container":"yAWmUBwF93_V4lUQ5YpZ"};